import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import A1 from 'assets/A1.svg?react';
import A2 from 'assets/A2.svg?react';
import B1 from 'assets/B1.svg?react';
import B2 from 'assets/B2.svg?react';
import C1 from 'assets/C1.svg?react';
import C2 from 'assets/C2.svg?react';
import { CEFR_LEVELS } from 'pages/VocabularyTest/cefr';
import { formatTestDuration } from 'pages/VocabularyTest/resultFormat';

interface TestResultHeroProps {
  orientedLevel: string;
  durationOfComplete: string;
}

const LEVEL_ICONS: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  A1,
  A2,
  B1,
  B2,
  C1,
  C2,
};

const TestResultHero: React.FC<TestResultHeroProps> = ({
  orientedLevel,
  durationOfComplete,
}) => {
  const level = CEFR_LEVELS.find((l) => l.id === orientedLevel);
  const LevelIcon = level ? LEVEL_ICONS[level.id] : undefined;

  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'primary.tableBorder',
        borderRadius: 2,
        boxShadow: '0 14px 36px -28px rgba(20,20,20,0.4)',
        p: { xs: 2.5, md: '28px 30px' },
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={{ xs: 2.5, md: 3.75 }}
        divider={
          <Divider
            orientation={'vertical'}
            flexItem
            sx={{ display: { xs: 'none', md: 'block' } }}
          />
        }
        alignItems={{ xs: 'flex-start', md: 'center' }}
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          spacing={2.25}
          sx={{ flex: 1, minWidth: 0 }}
        >
          {LevelIcon && (
            <Box
              sx={{
                flex: 'none',
                '& svg': { width: { xs: 64, md: 88 }, height: 'auto' },
              }}
            >
              <LevelIcon />
            </Box>
          )}
          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{ color: 'text.secondary', fontSize: 13, fontWeight: 700 }}
            >
              {'Твій рівень'}
            </Typography>
            <Typography
              sx={{
                color: 'primary.main',
                fontSize: { xs: 26, md: 32 },
                fontWeight: 800,
                lineHeight: 1.1,
              }}
            >
              {level ? `${level.id} · ${level.name}` : orientedLevel}
            </Typography>
            {level && (
              <Typography
                sx={{
                  color: 'text.secondary',
                  fontSize: 13,
                  lineHeight: 1.4,
                  mt: 0.4,
                }}
              >
                {level.desc}
              </Typography>
            )}
          </Box>
        </Stack>

        <Stack sx={{ flex: 'none', minWidth: { md: 200 } }} spacing={0.5}>
          <Stack
            direction={'row'}
            alignItems={'center'}
            spacing={0.75}
            sx={{ color: 'text.secondary', fontSize: 13, fontWeight: 600 }}
          >
            <ScheduleIcon sx={{ fontSize: 18 }} />
            <Box component={'span'}>{'Час проходження'}</Box>
          </Stack>
          <Typography sx={{ fontSize: 22, fontWeight: 800 }}>
            {formatTestDuration(durationOfComplete)}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default TestResultHero;
